window.SITE_ENV = 'cn'
const SITE_ENV =
  document.querySelector('html')?.getAttribute('SITE_ENV') ||
  process.env.VUE_APP_SITE_ENV ||
  window.SITE_ENV
if (SITE_ENV == 'cn') {
  createScript(`
      ;(function (win, export_obj) {
        win['TeaAnalyticsObject'] = export_obj
        if (!win[export_obj]) {
          function _collect() {
            _collect.q.push(arguments)
          }
          _collect.q = _collect.q || []
          win[export_obj] = _collect
        }
        win[export_obj].l = +new Date()
      })(window, 'collectEvent')
      `)
  createScript(
    '',
    'https://sf1-scmcdn-tos.pstatp.com/goofy/log-sdk/collect/collect-autotrack-rangers.js',
    'async'
  )
} else {
  createScript(
    '',
    'https://www.googletagmanager.com/gtag/js?id=' +
      (process.env.VUE_APP_TICO_ENV !== 'prd'
        ? 'G-ZXREYFF68B'
        : 'G-HCS9NB8RJX'),
    'async'
  )
  createScript(`window.dataLayer = window.dataLayer || []
      function gtag() {
        window.dataLayer.push(arguments)
      }
      window.gtag = gtag
    `)
}

function createScript(html, src, async) {
  var js = document.createElement('script')
  document.getElementsByTagName('head')[0].appendChild(js)
  if (html) {
    js.innerHTML = html
  }
  if (src) {
    js.src = src
  }
  if (async) {
    js.setAttribute('async', async)
  }
}
